const palette = {
	primary: {
		main: "#1978ba",
		// main: '#2b5384',
		contrastText: "#FFF",
	},
	idea: {
		main: "#24C1A8",
		contrastText: "#FFF",
	},
	text: {
		primary: "#313237",
		secondary: "#505050",
	},
};
export default palette;
